 <template>
    <div class="alet_container">
	    <section class="tip_text_container">
            <div class="tip_text">
                <p v-html="alertText"></p>
            </div>
            <div class="confrim" @click="closeTip">
                <p>确&nbsp;认</p>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
    	data(){
            return{
                positionY: 0,
                timer: null
                // configure:{}
            }
        },
        created(){
            // let _this = this;
            // let baseStyle = localStorage.getItem("baseStyle");
            // _this.configure = JSON.parse(baseStyle); //转为JSON
        },
        mounted(){
      
        },
        computed: {
            // themeColor(){//主题色
            //     return {
            //         backgroundColor:this.configure.rbg_color
            //     }
            // }
        },
        props: ['alertText'],
        methods: {
            closeTip(){
                this.$emit('closeTip')
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../assets/css/mixin';

	@keyframes tipMove{
       0%   { transform: scale(1) }
       35%  { transform: scale(.8) }
       70%  { transform: scale(1.1) }
       100% { transform: scale(1) }
    }
    @-webkit-keyframes tipMove{
       0%   { transform: scale(1) }
       35%  { transform: scale(.8) }
       70%  { transform: scale(1.1) }
       100% { transform: scale(1) }
    }
    .alet_container{
    	position: fixed;
    	top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 999;
    }
    .tip_text_container{
        width: 70%;
        margin: 0 auto;
        background-color: #fff;
        border-radius: 0.25rem;
        text-align: center;
        margin-top: 20%;
        animation: tipMove .4s ;
        -webkit-animation: tipMove .4s ;
        .confrim{
            line-height: 1.8rem;
            border-top: 1px solid#888;
            color:#4886ff;
            padding: 1rem 0;
        }
        .tip_text{
            height: 8rem;
            position: relative;
        }
        .tip_text p{
            width: 100%;
            position: absolute;
            top: 50%;
            transform: translateY(-50%,);
        }
    }
    
</style>



// WEBPACK FOOTER //
// src/components/alertTip.vue